/*! @azure/msal-browser v3.28.0 2024-12-12 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.28.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
